var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFavouritesIcon = function SvgFavouritesIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#BFBFBF",
    fillRule: "evenodd",
    d: "M4.708 17.917a1.15 1.15 0 0 1-1.151-1.153V5.346c0-2.073 1.449-3.262 3.976-3.262h4.931c2.563 0 3.975 1.21 3.975 3.405l.004 11.272a1.155 1.155 0 0 1-1.72 1.003l-4.702-2.656-4.748 2.662a1.17 1.17 0 0 1-.565.147m3.987-6.921a.62.62 0 0 0 .884 0l3.447-3.445a.625.625 0 0 0-.884-.884L9.137 9.67 7.855 8.389a.625.625 0 0 0-.884.884z",
    clipRule: "evenodd"
  })));
};
export default SvgFavouritesIcon;